import React, { RefObject, useState } from 'react'
import Draggable from 'react-draggable'
import { useVideoStore } from '../VideoSetting'
import Loading from '../components/Loading'
import classNames from 'classnames'

type Props = {
  localVideoRef: RefObject<HTMLVideoElement>
}

const LocalVideo: React.FC<Props> = ({ localVideoRef }) => {
  const { screen, video, webcamAccess } = useVideoStore(state => ({
    screen: state.screen,
    video: state.video,
    webcamAccess: state.webcamAccess,
  }))

  const [min, setMin] = useState(false)

  const minimize = () => {
    setMin(!min)
  }

  const [x, setX] = useState(0)
  const [y, setY] = useState(0)

  const handleStop = (event, dragElement) => {
    setX(dragElement.x)
    setY(dragElement.y)
  }

  return (
    <>
      <Draggable
        onStop={handleStop}
        axis={min ? 'none' : 'both'}
        defaultPosition={min ? { x: 0, y: 50 } : { x: 0, y: 0 }}
      >
        <div
          className={classNames('janus__local', { 'janus__local--min': min })}
        >
          {!webcamAccess && !screen && (
            <div className="janus__local-info">
              <div className="janus__local-minimize" onClick={() => minimize()}>
                {min ? (
                  <i className="fas fa-plus"></i>
                ) : (
                  <i className="fas fa-minus"></i>
                )}
              </div>
              <i className="fas fa-webcam-slash"></i>{' '}
              {intl.formatMessage({ id: 'janus.video.noWebcam' })}
            </div>
          )}
          {webcamAccess && !video && !screen && (
            <div className="janus__local-info">
              <div className="janus__local-minimize" onClick={() => minimize()}>
                {min ? (
                  <i className="fas fa-plus"></i>
                ) : (
                  <i className="fas fa-minus"></i>
                )}
              </div>
              <i className="fas fa-webcam-slash"></i>
            </div>
          )}
          <div
            className={classNames('janus__local-video', {
              'janus__local--min': min,
            })}
          >
            <div className="janus__local-minimize" onClick={() => minimize()}>
              {min ? (
                <i className="fas fa-plus"></i>
              ) : (
                <i className="fas fa-minus"></i>
              )}
            </div>
            <video
              ref={localVideoRef}
              id="video-local"
              autoPlay
              playsInline
              muted
              style={{ display: 'block' }}
            />
          </div>
          <div className="janus__local-loading">
            <Loading small={true} />
          </div>
        </div>
      </Draggable>
    </>
  )
}

export default LocalVideo
